import React from 'react'
import DataComponent from 'EurestoComponents/DataComponent'
import Constants from 'EurestoFonction/Constants'

export default class extends React.Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props.information_tiers[this.props.info.id] !== nextProps.information_tiers[nextProps.info.id] || this.props.disabled !== nextProps.disabled
  }

  constructor(props) {
    super(props)
  }

  render() {
    let libelle = this.props.info.libelle
    const RelationSociete = (this.props.contact.relations || []).find(r => r.relation_id === 1017)
    if (this.props.info.id === 6 && RelationSociete) {
      const RelationsSociete = (this.props.contact.relations || []).filter(r => r.relation_id === 1017 && r.contact_id !== undefined)
      if (RelationsSociete.length > 0) {
        libelle = <span>{libelle}
          (<span style={{
            color: EurestoColor('EurestoError'),
            textDecoration: 'underline'
          }}>{RelationsSociete.map(RelationSociete => RelationSociete.contact_libelle).join(', ')}</span>)</span>
      }
    }
    return <DataComponent key={this.props.info.id} title={libelle} onChange={this.props.onChangeInfo}
      inline={this.props.inline}
      name={this.props.info.id} disabled={this.props.disabled} client_id={this.props.contact.id} infoTiers
      object={Constants.donnee.info_tiers_donnees} module={Constants.module.CRM} search={{
        information_tiers_id: this.props.info.id,
        actif: {
          not: true,
          value: 3
        }
      }} data={this.props.information_tiers[this.props.info.id]} type={this.props.info.type_saisie_id} />
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/InformationTiers/Data.js